import { useQuery } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";
import { BaseResponse } from "../_types";
import { QueryKeys } from "../queryKeys";

interface ISearchFixedEftPosRequest {
  taxNo: string;
}

type ISearchFixedEftPosResponse = BaseResponse<any>;

async function searchFixedEftPos(taxNo: string): Promise<ISearchFixedEftPosResponse> {
  try {
    const response = await axiosInstance.get("/Todeb/SearchFixedEftPos", {
      params: { taxNo }
    });
    return response.data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any)?.error;
  }
}

export function useSearchFixedEftPos(taxNo?: string) {
  return useQuery<any | undefined, Error>(
    [QueryKeys.SearchFixedEftPos, taxNo],
    () => searchFixedEftPos(taxNo!),
    { enabled: !!taxNo }
  );
}
